import React from 'react';
import {
	Content,
	Label,
	TableCellChart,
	TableCellGroup,
	TableCellGroupDiv,
	TableCellMax,
	TableCellMin,
	TableCellPeerCount,
	TableRow,
	ToggleButton,
} from './CategoryHierarchy.styles';
import LinearGauge from '../LinearGuage/LinearGauge';
import { ApIcon } from '@alixpartners/ui-components';

const CategoryHierarchy = props => {
	const { data, onExpand, onToggle } = props;
	return (
		<>
			{data.map(items => {
				const {
					name,
					level,
					peerCount,
					min,
					max,
					median,
					clientSpend,
					children,
					isExpanded,
					group,
				} = items;
				const hasChildren = children.length > 0;
				const icon = isExpanded
					? 'baseline_keyboard_arrow_down'
					: 'baseline_keyboard_arrow_right';
				return (
					<>
						<TableRow group={group} level={level}>
							<TableCellGroup>
								<TableCellGroupDiv level={level}>
									<ToggleButton
										onClick={
											hasChildren
												? () => onToggle(level, name, group, isExpanded)
												: () => onExpand(group, level, name)
										}
									>
										<ApIcon iconName={icon} iconColor="black" />
									</ToggleButton>
									<Label> {name} </Label>
								</TableCellGroupDiv>
							</TableCellGroup>
							<TableCellPeerCount>
								<Content>
									<Label> {peerCount} </Label>
								</Content>
							</TableCellPeerCount>
							<TableCellMin>
								<Content>
									<Label> {min} </Label>
								</Content>
							</TableCellMin>
							<TableCellChart>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<LinearGauge
										values={{ group, level, min, max, median, clientSpend }}
									/>
								</div>
							</TableCellChart>
							<TableCellMax>
								<Content>
									<Label> {max} </Label>
								</Content>
							</TableCellMax>
						</TableRow>
						{isExpanded && (
							<>
								{hasChildren &&
									children.map(child => (
										<CategoryHierarchy
											key={Math.random()}
											data={[child]}
											onExpand={onExpand}
											onToggle={onToggle}
										/>
									))}
							</>
						)}
					</>
				);
			})}
		</>
	);
};

export default CategoryHierarchy;
